export default "__VITE_ASSET__BhPJDoH4__"